import axios from 'axios';


export default {
    saveFirstEmailConfiguration:(data)=>{
        return axios.post('admin/actualizar/primer/correo', data);
    },
    saveReminderEmailConfiguration:(data)=>{
        return axios.post('admin/actualizar/recordatorio/correo', data);
    },
    saveApprovedEmailConfiguration:(data)=>{
        return axios.post('admin/actualizar/aprobacion/correo', data);
    },
    updateDefaultValues(data){
        return axios.post('admin/actualizar/valores/defecto', data);
    },
    getMembersList(){
        return axios.get('equipo/listado')
    },
    deleteTeamMember(id){
        return axios.delete('admin/eliminar/usuario/'+id);
    },
    sendInvitation(data){
        return axios.post('admin/invitar/usuario', data);
    },
    selectAdmin(data){
        return axios.get('admin/hacer/dueno', data)
    },
    getGeneralSettings(){
        return axios.get('catalogos/valores/defecto')
    },
    exportClients(data){
        return axios.post('admin/exportar/usuarios', data);
    }
}